export default {
  message: {
    "error": "Ups! Coś poszło nie tak.",
    "Sorrysomeerrorsoccurred": "Wystąpił nieoczekiwany błąd. Możesz spróbować zmienić język lub wyjść i ponownie uruchomić aplikację.",
    "quit": "Wyjdź",
    "language": "Język",
    "Youcanchangethelanguagehere": "Możesz zmienić język tutaj!",
    "current": "Aktualny",
    "home": "Strona główna",
    "friends": "Znajomi",
    "wallet": "Portfel",
    "aboutus": "O nas",
    "Sharewithfriends": "Podziel się z przyjaciółmi",
    "copyFailure": "Niepowodzenie kopiowania",
    "copySuccess": "Sukces kopiowania",
    "Claimreward": "Zbierz nagrodę",
    "DailyLogin": "Codzienne logowanie",
    "noInvitationsYet": "Brak zaproszeń jeszcze",
    "LoadMore": "Załaduj więcej",
    "WatchAD": "Oglądaj reklamę",
    "continue": "Kontynuuj",
    "Congratulations": "Gratulacje",
    "MyFriends": "Moi przyjaciele",
    "Invitefriends": "Zaprosić przyjaciół",
    "Invitepremiumfriends": "Zaprosić premium przyjaciół",
    "DailyTasks": "Zadania codzienne",
    "inviteDesc": "+{num} ${name} za każdego zaproszonego przyjaciela",
    "DailyTasksDesc": "Wykonaj zadania, aby zdobyć więcej airdropów",
    "SponsorsandPartners": "Sponsorzy i partnerzy",
    "Receivingwallet": "Portfel odbierający",
    "Enterwalletaddress": "Wprowadź adres portfela {name}",
    "Claim": "Zbierz",
    "Booster": "Booster",
    "RentPeriod": "Okres wynajmu",
    "days30": "30 dni",
    "Dailyprofit": "Dzienny zysk",
    "Totalprofit": "Łączny zysk",
    "Quantity": "Ilość",
    "RentPrice": "Cena wynajmu",
    "RentMiner": "Wynajmij górnika",
    "Insufficient": "Nie wystarczająca liczba zaproszonych",
    "InsufficientMsg": "Musisz zaprosić {num} przyjaciół, aby zarobić więcej akcesoriów.",
    "Settings": "Ustawienia",
    "copyid": "Kopiuj ID",
    "UpgradeSuccessfully": "Uaktualnienie powiodło się",
    "Name": "Nazwa",
    "userinfo": "Informacje o użytkowniku",
    "disconnect": "Rozłącz",
    "Startmining": "Rozpocznij wydobywanie",
    "Welcome": "Witaj w {name}",
    "Withdrawal": "Wypłata",
    "Minimumamount": "Minimalna kwota",
    "Networkfee": "Opłata sieciowa",
    "Enteramount": "Wprowadź kwotę",
    "Submit": "Wyślij",
    "MinimumTip": "Kwota wypłaty jest za mała. Minimalna kwota wypłaty: {num}",
    "MaximumTip": "Niewystarczająca kwota, maksymalna kwota wypłaty to: {num}",
    "SubmittedTip": "Wysłano, oczekujemy przetworzenia w ciągu 30-60 dni roboczych",
    "WebSubmittedTip": "Wysłano, przetworzymy to tak szybko, jak to możliwe.",
    "WithdrawStatus": "Status",
    "Submissiontime": "Czas wysłania",
    "WithdrawAwaitTip": "* Szacuje się, że zajmie to 30-60 dni roboczych. Zaproszenie większej liczby przyjaciół może przyspieszyć proces przeglądu.",
    "WebWithdrawAwaitTip": "* Szacuje się, że zajmie to 24-48 godzin. Zaproszenie większej liczby przyjaciół może przyspieszyć proces przeglądu.",
    "Processing": "Przetwarzanie",
    "Success": "Sukces",
    "Rejection": "Odrzucone",
    "Amount": "Kwota",
    "Numberoffriends": "Liczba przyjaciół: {now}/{limit}",
    "InviteTip": "Aby dokonać pierwszej wypłaty, musisz zaprosić {limit} przyjaciół do dołączenia do aplikacji wydobywczej.",
    "openonphone": "Otwórz ten link na swoim telefonie.",
    "claimTip": "Kwota do odebrania jest za mała. Minimalna kwota do odebrania to: {num}",
    "WalletBalance": "Stan portfela",
    "Withdraw": "Wypłać",
    "SetWalletAddress": "Ustaw adres portfela",
    "WithdrawalRecord": "Historia wypłat",
    "Norecords": "Brak zapisów",
    "Whatis": "Co to jest {name}?",
    "All": "Wszystko",
    "save": "Zapisz",
    "successWithdrawal": "Skanning zakończony sukcesem {num}",
    "secondsago": "{time} sekund temu",
    "Loading": "Ładowanie...",
    "PaymentConfirming": "Sprawdzanie statusu transakcji...",
    "Check": "Sprawdź",
    "CheckFail": "Transakcja nie została zrealizowana. Proszę sprawdzić ponownie za 5 sekund.",
    "Addname": "Dodaj '{name}' do swojego imienia",
    "Restattcheck": "Uruchom ponownie aplikację, aby sprawdzić",
    "Copyname": "Skopiuj '{name}'",
    "SubmissionFailed": "Wysłanie nie powiodło się, spróbuj ponownie później",
    "WithdrawalReview": "Przegląd wypłaty",
    "select_payment_method": "Wybierz metodę płatności",
    "total_amount": "Łączna kwota",
    "next_step": "Następny krok",
    "creating_order": "Tworzenie zamówienia...",
    "order_created": "Zamówienie utworzone",
    "order_status": "Status zamówienia",
    "order_id": "ID zamówienia",
    "order_amount": "Kwota zamówienia",
    "order_status_desc": "Opis statusu zamówienia",
    "payment_cancelled": "Płatność anulowana",
    "opening_payment": "Otwarcie płatności...",
    "payment_success": "Płatność zakończona sukcesem",
    "payment_failed": "Płatność nie powiodła się",
    "payment_pending": "Płatność w toku",
    "payment_processing": "Płatność w przetwarzaniu",
    "create_order_failed": "Tworzenie zamówienia nie powiodło się",
    "creating_ton_order": "Tworzenie zamówienia TON...",
    "check_payment_status": "Sprawdzanie statusu płatności...",
    "use_ton_payment": "Użyj płatności TON",
    "connect_wallet": "Połącz portfel",
    "start_transaction": "Rozpocznij transakcję",
    "address": "Adres",
    "amount_ton": "Kwota TON",
    "copy": "Skopiuj",
    "comment_memo": "Komentarz notatka",
    "comment_memo_desc": "Proszę wprowadzić komentarz notatka",
    "comment_memo_placeholder": "Wprowadź komentarz notatka",
    "amount": "Kwota",
    "wallet_address": "Adres portfela",
    "you_can_choose_to_connect_wallet_to_pay": "Możesz wybrać połączenie portfela, aby zapłacić",
    "or_manually_transfer_to_the_above_address": "Lub ręcznie przelać na powyższy adres (zauważ, że kwota i notatka muszą być dokładnie takie same)",
    "transaction_success": "Transakcja zakończona sukcesem",
    "transaction_failed": "Transakcja nie powiodła się",
    "transaction_error": "Błąd transakcji",
    "transaction_status": "Status transakcji",
    "transaction_id": "ID transakcji",
    "transaction_amount": "Kwota transakcji",
    "transaction_status_desc": "Opis statusu transakcji",
    "miner_detail": "Szczegóły górnika",
    "rent_period": "Okres wynajmu",
    "days": "{days} dni",
    "daily_yield": "Dzienny zysk",
    "total_yield": "Całkowity zysk",
    "invite_friends": "Zapraszaj przyjaciół",
    "price": "Cena",
    "rent": "Wynajem",
    "free_claim": "Bez opłaty za odbiór",
    "redeem": "Odbierz",
    "buy": "Wynajem",
    "invite_friends_not_enough": "Nie wystarczająco znajomych do zaproszenia",
    "redeem_success": "Odbiór zakończony sukcesem",
    "redeem_failed": "Odbiór nie powiódł się",
    "rent_success": "Wynajem zakończony sukcesem",
    "rent_failed": "Wynajem nie powiódł się",
    "TotalPower": "Całkowita moc",
    "MaxQuantity": "Osiągnięto maksymalną wartość",
    "Running": "Trwa",
    "Stop": "Stop",
    "Withdrawalunlock": "Odblokowywanie wypłaty",
    "Close": "Zamknij",
    "Delivering": "Dostarczenie",
    "Duetothelargenumber": "Z powodu dużej liczby odbiorców, Twój airdrop ma przybyć w ciągu 15-20 dni roboczych",
    "WithdrawalunlockTip": "Potrzebujesz {num} zaproszonych znajomych, aby ukończyć zadania/podłączyć portfele, aby odblokować wypłatę",
    "mining_title": "Robot",
    "Upgrade": "Ulepsz",
    "partner": "Partner",
    "faq": "FAQ",
    "task": "Zadanie",
    "OpenRobot": "Otwórz Robota",
    "MyRobot": "Mój Robot",
    "Level": "Poziom",
    "Commission": "Prowizja",
    "DirectFriends": "Bezpośredni Przyjaciele",
    "Feedback": "Opinie",
    "Pleaseenteryouremailaddress": "Proszę wpisać swój adres e-mail",
    "Inputfeedbackcontent": "Wprowadź treść opinii",
    "Submitfeedback": "Prześlij opinię",
    "Feedbacksubmittedsuccessfully,thankyouforyourvaluablefeedback": "Opinie zostały pomyślnie przesłane, dziękujemy za cenne uwagi",
    "Feedbacksubmissionfailed,pleaseretriy": "Wysyłanie opinii nie powiodło się, spróbuj ponownie",
    "Addressformaterror": "Błąd formatu adresu",
    "Readclipboardfailed": "Nie udało się odczytać schowka",
    "Youhavealreadyfeedbackedtoday,pleasecomebacktomorrow": "Już dzisiaj wysłałeś opinię, wróć jutro",
    "Record": "Rekord",
    "Newuserguidance": "Wyświetl trasę powitalną",
    "Usetonwallet": "Użyj portfela TON",
    "Reward": "Nagroda",
    "Connectwallet": "Połącz portfel",
    "Notconnected": "Niepołączony",
    "Disconnect": "Odłącz",
    "AboutTAI": "Szczegóły tokena",
    "WithdrawalRecordDesc": "Historia wypłat",
    "StartAItrading": "Rozpocznij handel AI",
    "Next": "Następny",
    "Start": "Rozpocznij",
    "WithdrawalSuccess": "Wypłata powiodła się",
    "WithdrawalFail": "Wypłata nie powiodła się",
    "Max": "Max",
    "WithdrawalRecords": "Historia Wypłat",
    "Commissionrules": "Reguły prowizji",
    "Mycommission": "Moja prowizja",
    "Shop": "Sklep",
    "BuyDifferentAIrobots": "Zaktualizuj za pomocą urządzeń obliczeniowych dla szybszych skanów!",
    "CurrentRunningAIrobots": "Aktualnie działające roboty AI",
    "DailyProfit": "Codzienny zysk",
    "Buy": "Kup",
    "ValidityPeriod": "Okres ważności",
    "Days": "Dni",
    "Price": "Cena",
    "APY": "APY",
    "NoRobot": "Brak mocy obliczeniowej",
    "RemainingTime": "Pozostały czas",
    "InviteandEarn": "Zaproś i zarabiaj",
    "InvitDec": "Zaproś swoich przyjaciół do handlu AI i zarabiaj prowizje USDT oraz tokeny airdrop razem!",
    "ShareToGroups": "Udostępnij do grup",
    "Select_payment_method": "Wybierz metodę płatności",
    "twa_pay_tip_with_memo": "Proszę upewnić się, że adres, kwota i notatka są zgodne z transferem.",
    "twa_pay_tip": "Proszę upewnić się, że adres i kwota są poprawne w przypadku transferu.",
    "twa_pay_tip_placeholder": "Wpisz notatkę komentarza",
    "twa_pay_tip_placeholder_with_memo": "Wpisz notatkę komentarza z notatką",
    "twa_pay_tip_placeholder_without_memo": "Wpisz notatkę komentarza bez notatki",
    "twa_pay_tip_placeholder_with_memo_placeholder": "Wpisz notatkę komentarza z notatką",
    "twa_pay_tip_placeholder_without_memo_placeholder": "Wpisz notatkę komentarza bez notatki",
    "realtime_ai": "Handel AI w czasie rzeczywistym",
    "check_transaction_status": "Sprawdź status transakcji",
    "transaction_wait": "Transakcja jest w toku. Możesz opuścić aplikację. Otrzymasz powiadomienie, gdy zostanie zakończona.",
    "Pleaseenteravalidemailaddress": "Proszę podać prawidłowy adres e-mail",
    "max_robot_tip": "Osiągnięto limit zakupu — spróbuj innego planu, aby kontynuować handel!",
    "connectFailure": "Łączenie portfela nie powiodło się",
    "connectSuccess": "Łączenie portfela zakończone sukcesem",
    "PayNow": "Zapłać teraz",
    "min_withdrawal_amount": "Minimalna kwota wypłaty wynosi {num} {coin_name}",
    "max_withdrawal_amount": "Maksymalna kwota wypłaty wynosi {num} {coin_name}",
    "balance_not_enough": "Nie masz wystarczającego salda na tę wypłatę.",
    "Numberofgroups": "Liczba grup: {now}/{limit}",
    "Withdraw_success": "Wypłata zakończona sukcesem",
    "allProfit": "Całkowity zysk",
    "AnnualProfit": "Zysk roczny",
    "ScanWallet": "Przeskanuj portfel",
    "wallet_check": "wallet_check",
    "Found": "Znaleziono",
    "ScanSpeed": "Prędkość skanowania",
    "MyComputingPower": "Obliczenia",
    "Scanning": "Skanowanie!",
    "WithdrawDetail": "Szczegóły wypłaty",
    "ScanSuccess": "Twój wskaźnik sukcesu skanowania wzrósł!",
    "TaskDescription": "Wykonuj zadania, aby zwiększyć wskaźnik sukcesu skanowania!",
    "InitializingMiningSystem": "Inicjalizowanie systemu skanowania...",
    "NoWithdrawalRecord": "Brak rekordu wypłaty",
    "Invite": "Wymagane zaproszenia",
    "Free": "Bezpłatnie",
    "Confirm": "Potwierdź",
    "RefreshTasks": "Odśwież zadania",
    "NumberofGroups": "Liczba grup: {now}/{limit}",
    "SendMessage": "Wyślij wiadomość",
    "NumberofShares": "Liczba udziałów: {now}/{limit}",
    "NumberofTasks": "Liczba zadań: {now}/{limit}",
    "CompleteTask": "Ukończ zadanie",
    "Accelerated": "Przyspieszone",
    "Accelerated_withdrawals_success": "Przyspieszone wypłaty z powodzeniem",
    "GoBuy": "Kup teraz",
    "SpeedUpScan": "Przyspiesz",
    "Earnings": "Zarobki",
    "learnMore": "Dowiedz się więcej",
    "claimSuccess": "Odbiór zakończony sukcesem",
    "claimFailed": "Odbiór nie powiódł się, spróbuj ponownie",
    "noDividends": "Brak dywidend do odebrania",
    "dividendsInfoFallback": "Zapraszaj przyjaciół, aby zarobić nagrody za polecenie"
}};